/**
 * @generated SignedSource<<29989ccf170ccff9a56e161bc483f9c4>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionScoringCriteriaFragmentQuery$variables = {
  id: string;
  stage?: number | null | undefined;
};
export type CompetitionScoringCriteriaFragmentQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"CompetitionScoringCriteriaFragment">;
  };
};
export type CompetitionScoringCriteriaFragmentQuery = {
  response: CompetitionScoringCriteriaFragmentQuery$data;
  variables: CompetitionScoringCriteriaFragmentQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "stage"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v3 = [
  {
    "kind": "Variable",
    "name": "stage",
    "variableName": "stage"
  }
],
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": (v3/*:: as any*/),
            "kind": "FragmentSpread",
            "name": "CompetitionScoringCriteriaFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "selections": [
      {
        "alias": null,
        "args": (v2/*:: as any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          (v4/*:: as any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v3/*:: as any*/),
                "concreteType": "CompetitionStage",
                "kind": "LinkedField",
                "name": "stage",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "seq",
                    "storageKey": null
                  },
                  {
                    "alias": "viewerCanEdit",
                    "args": [
                      {
                        "kind": "Literal",
                        "name": "action",
                        "value": "UPDATE_COMPETITION_STAGE"
                      }
                    ],
                    "kind": "ScalarField",
                    "name": "viewerCan",
                    "storageKey": "viewerCan(action:\"UPDATE_COMPETITION_STAGE\")"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "CompetitionScoringCriterion",
                    "kind": "LinkedField",
                    "name": "scoringCriteria",
                    "plural": true,
                    "selections": [
                      (v4/*:: as any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "title",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "description",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "weight",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v4/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "Competition",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "ed63b9158d0dd4675f129970228ea585",
    "id": null,
    "metadata": {},
    "name": "CompetitionScoringCriteriaFragmentQuery",
    "operationKind": "query",
    "text": "query CompetitionScoringCriteriaFragmentQuery(\n  $stage: Int\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...CompetitionScoringCriteriaFragment_YHaL6\n    id\n  }\n}\n\nfragment CompetitionScoringCriteriaFragment_YHaL6 on Competition {\n  slug\n  stage(stage: $stage) {\n    seq\n    viewerCanEdit: viewerCan(action: UPDATE_COMPETITION_STAGE)\n    scoringCriteria {\n      id\n      title\n      description\n      weight\n    }\n    id\n  }\n  id\n}\n"
  }
};
})();

(node as any).hash = "2cb98affb4d5585391b4dd472b691d91";

export default node;
